import apiClient from '../apiClient';

export const fetchSupportRequests = async () => {
  const response = await apiClient.get('/support/requests');
  return response.data ?? [];
};

export const createSupportRequest = async (payload) => {
  const response = await apiClient.post('/support/requests', payload);
  return response.data;
};
